interface DegradedCatalogBannerProps {
  message: string;
}

export function DegradedCatalogBanner({ message }: DegradedCatalogBannerProps) {
  return (
    <div
      className="rounded-[14px] border border-amber-300 bg-amber-50 px-3 py-2.5 text-sm text-amber-950 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-100"
      role="status"
    >
      <p className="font-semibold">Резервний режим каталогу</p>
      <p className="mt-1 text-xs leading-relaxed opacity-90">{message}</p>
      <p className="mt-1 text-[11px] font-medium uppercase tracking-wide opacity-70">
        read-only · checkout disabled
      </p>
    </div>
  );
}
